<template>
  <div class="app-container bj-label-colon">
    <BjDivider right-fixed
      >{{ $t('BusinessStockEntryResultView.title') }}
      <template slot="right">
        <el-button @click="handleClose">{{ $t('backText') }}</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="reFresh">{{ $t('refreshText') }}</el-button>
      </template>
    </BjDivider>
    <el-row>
      <el-col :span="12">
        <el-form>
          <el-form-item :label="$t('BusinessStockEntryResultView.code')">
            {{ data.code || noDataText }}
            <BjCopyIcon class="ml10" :copy="data.code" />
          </el-form-item>
          <el-form-item :label="$t('BusinessStockEntryResultView.receivingLogicWarehouseCode')">
            {{ data.receivingLogicWarehouseCode || noDataText }}
          </el-form-item>
          <el-form-item :label="$t('BusinessStockEntryResultView.receivingLogicWarehouseName')">
            {{ data.receivingLogicWarehouseName || noDataText }}
          </el-form-item>
          <el-form-item :label="$t('BusinessStockEntryResultView.inputTypeMeaning')">
            {{ data.inputTypeMeaning || noDataText }}
          </el-form-item>
          <el-form-item :label="$t('BusinessStockEntryResultView.statusMeaning')">
            {{ data.statusMeaning || noDataText }}
          </el-form-item>
          <!-- <el-form-item label="买家备注">
            {{ data.buyMsg || noDataText }}
          </el-form-item>
          <el-form-item label="商家备注">
            {{ data.orderMsg || noDataText }}
          </el-form-item> -->
        </el-form>
      </el-col>
      <el-col :span="12">
        <el-form>
          <el-form-item :label="$t('BusinessStockEntryResultView.returnsName')">{{ data.returnsName || noDataText }} </el-form-item>
          <el-form-item :label="$t('BusinessStockEntryResultView.returnsMobile')">{{ data.returnsMobile | phoneFilter }} </el-form-item>
          <el-form-item :label="$t('BusinessStockEntryResultView.cptAddress')">{{ cptAddress }} </el-form-item>
          <el-form-item :label="$t('table.createTimeText')">
            {{ data.creationDate || noDataText }}
          </el-form-item>
          <!-- <el-form-item label="创建人">
            {{ data.createdName || noDataText }}
          </el-form-item> -->
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <BjDivider>{{ $t('BusinessStockEntryResultView.associated') }}</BjDivider>
      <el-form inline>
        <el-col :span="8">
          <el-form-item :label="$t('BusinessStockEntryResultView.warehouseWarrantCode')">
            <span
              class="link"
              @click="$toBusinessStockEntryInformView(data.warehouseWarrantCode)"
              >{{ data.warehouseWarrantCode }}</span
            >
            <BjCopyIcon class="ml10" :copy="data.warehouseWarrantCode" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('BusinessStockEntryResultView.orderCode')">
            <span class="link" @click="$toBusinessOrderInternalView(data.orderCode)">{{
              data.orderCode
            }}</span>
            <BjCopyIcon class="ml10" :copy="data.orderCode" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('BusinessStockEntryResultView.platformOrderCode')">
            <span class="link" @click="$toBusinessThirdOrderView(data.platformOrderCode)">{{
              data.platformOrderCode
            }}</span>
            <BjCopyIcon class="ml10" :copy="data.platformOrderCode" />
          </el-form-item>
        </el-col>
      </el-form>
    </el-row>
    <BjDivider>{{ $t('BusinessStockEntryResultView.productInformation') }}</BjDivider>
    <!-- TODO:商品明细应该只有一条 by skyer-ebc-325 -->
    <BjPage
      ref="BjPage"
      :col-span="colSpan"
      :get-action="queryApi"
      :query-params="queryParams"
      :auto-fetch="false"
      :serial="serial"
      :selection="false"
      :stripe="false"
      search-btn-hide
      right-toolbar-hide
      row-key="id"
      no-auto-height
      @handleSelectionChange="handleSelectionChange"
    >
      <template #tableColumn>
        <!-- <el-table-column :label="$t('goodsPage.spuCode')" prop="spuCode" align="center" /> -->
        <el-table-column :label="$t('BusinessStockEntryResultView.table.skuName')" prop="skuName" align="center" />
        <el-table-column :label="$t('BusinessStockEntryResultView.table.skuCode')" prop="skuCode" align="center" />
        <el-table-column :label="$t('BusinessStockEntryResultView.table.alreadyInputQty')" prop="alreadyQty" align="center" />
        <!-- <el-table-column :label="$t('goodsPage.spuName')" prop="spuName" align="center" /> -->
      </template>
      <template #paginationLeft>
        <span class="ml20">{{ $t('BusinessStockEntryResultView.alreadyTotalQty') }}：{{ data.alreadyQty }}</span>
      </template>
    </BjPage>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import viewMiXin from '@/utils/view-mixin.js';
import { stockApi } from '@/api';
export default {
  name: 'BusinessStockEntryResultView',
  components: {},
  mixins: [pageMiXin, viewMiXin],
  props: {},
  data() {
    return {
      queryApi: stockApi.getEntryResultDetailGoods,
      queryParams: {
        warehouseResultId: null,
      },
      colSpan: 12,
      id: null,
      data: {
        alreadyTotalQty: null,
        channelTypeCode: null,
        channelTypeCodeMeaning: null,
        city: null,
        code: null,
        country: null,
        creationDate: null,
        district: null,
        frontRecordCode: null,
        frontRecordId: null,
        frontRecordType: null,
        id: null,
        inputType: null,
        inputTypeMeaning: null,
        logisticsList: [
          // {
          //   logisticsCompanyName: null,
          //   logisticsNo: null,
          // },
        ],
        orderCode: null,
        platformOrderCode: null,
        province: null,
        receivingLogicWarehouseCode: null,
        receivingLogicWarehouseName: null,
        returnsAddress: null,
        returnsMobile: null,
        returnsName: null,
        returnsTel: null,
        status: null,
        statusMeaning: null,
        storeName: null,
        totalQty: null,
      },
      noDataText: this.$t('BusinessStockEntryResultView.noDataText'),
    };
  },
  computed: {
    cptAddress() {
      let text = '';
      text += this.data.province || '';
      text += this.data.city || '';
      text += this.data.district || '';
      text += this.data.returnsAddress || '';
      return text;
    },
  },
  created() {
    this.reFresh();
  },
  mounted() {},
  methods: {
    reFresh() {
      stockApi
        .detailEntryResult({ id: this.$route.query.id, code: this.$route.query.code })
        .then(res => {
          if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
            this.data = Object.assign({}, this.data, res || {});
            if (this.data.id) {
              this.queryParams.warehouseResultId = this.data.id;
              this.$refs.BjPage.fetchData();
            }
          }
        });
    },
    onView(type) {
      switch (type) {
        case 0:
          // TODO: 这里需要以后过来接，现在没数据
          // this.msgSuccess('跳转前置页面');
          break;
        case 1:
          this.$toBusinessOrderInternalView(this.data.orderCode);
          break;
        case 2:
          // TODO: 这里需要以后过来接，现在没数据
          this.$toBusinessThirdOrderView(this.data.platformOrderCode);
          break;
      }
    },
    handleClose() {
      this.cancel();
    },
    /** 查看更多 */
    onMore() {
      this.$refs.codeTable.show(this.data.logisticsList);
    },
  },
};
</script>
<style lang="scss" scoped>
.el-form-item--mini.el-form-item {
  margin-bottom: 5px;
}
</style>
